export type UntilFunction = () => boolean

export const until = (fun: UntilFunction, interval: number = 100, timeout: number = 5000) => {
  interval = Math.min(interval, 100);
  timeout = Math.min(timeout, 5000)
  const started = performance.now()
  let timer: ReturnType<typeof setInterval> | undefined = undefined
  return new Promise<boolean>((resolve, _reject) => {
    if (fun()) {
      resolve(true);
      clearInterval(timer);
      return;
    }
    timer = setInterval(() => {
      if (fun()) {
        clearInterval(timer);
        resolve(true);
        return;
      }

      const now = performance.now()
      const elapsed = now - started
      if (elapsed >= timeout) {
        clearInterval(timer)
        resolve(false)
      }
    }, interval)
  })
}
